<div *ngIf="!isWalletConnected" class="wallet-connect-wrapper">
  <button id="custom-button" (click)="openModal()" class="wallet-connect-btn">
    <div class="btn-content">
      <img src="./assets/img/WeWorldWalletLogo.svg" alt="Connect Wallet Icon" class="icon-left" >
      <span></span><span>Connect Wallet</span>
    </div>
  </button>
</div>
<div *ngIf="isWalletConnected" class="wallet-connect-wrapper">
  <button id="custom-button" (click)="disconnectWallet()">
    {{walletAddress}}
  </button>
</div>
<div>
  <ng-template [ngIf]="isOwner && !isLoading">
    <app-content-control app-content-control *ngIf="controls" [contentControls]="controls"></app-content-control>
    <!-- <pre><code><small>{{asset | json }}</small></code></pre> -->
  </ng-template>
  <ng-template [ngIf]="!isOwner && !isLoading">
    <p class="text-center">NFT is not present in your wallet</p>
  </ng-template>
</div>